module.exports = __webpack_public_path__ + "img/in-maintenance-bike.8692258b.svg";